// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {PropTypes} from 'react';

// utilities
import _ from 'lodash';
import prettyDate from '../../../lib/prettyDate';
import emailLink from '../../../lib/emailLink';

// components
import RibbonIcon from '../../../common/svgs/Ribbon';
import EditIcon from '../../../common/svgs/EditIcon';
import GuideIcon from '../../../common/svgs/GuideIcon';
import DocumentIcon from '../../../common/svgs/DocumentIcon';
import DropDownMenu from '../../../common/components/c_DropDownMenu';
import FlatButton from '../../../common/components/c_FlatButton';
import prettyPhone from '../../../lib/prettyPhone';
import prettyAddress from '../../../lib/prettyAddress';
import IconButton from 'material-ui/IconButton';

import * as impersonationApi from '../../../redux/actionCreators/async/impersonation';
import { APPLICANT_STATUS } from '../../../redux/helpers/staticData';
import {isQualified} from '../../applicant/helpers/status';

const dropDownCustomization = {
  labelStyle: {
    color: '#ffffff',
    paddingLeft: '10px',
  },
};

FrontView.propTypes = {
  statusColor: PropTypes.string,
  staticData: PropTypes.object,
  applicant: PropTypes.object,
  profile: PropTypes.object,
  user: PropTypes.object,
  followUpTask: PropTypes.object,
  stateToggle: PropTypes.func,
  toggleGuide: PropTypes.func,
  onStatusChange: PropTypes.func,
  style: PropTypes.object,
  route: PropTypes.object
};

export default function FrontView(props) {
  const {
    user,
    profile
  } = props.applicant;

  const currentUser = props.user;

  const qualifyingSpecialistsKeyById = _.keyBy(props.staticData.qualifyingSpecialists, 'employeeId');

  const selectedStatus = _.get(props.tempState, 'applicantStatus.id', null) || _.get(props.applicant.profile, 'applicantStatus.id', null);
  const stateName = _.isNumber(user.state) ? (_.find(props.staticData.stateList, {id: user.state}) ? _.find(props.staticData.stateList, {id: user.state}).name : 'N/A') : (user.state || {}).name;

  // Get hash query for guide.
  let hash = '';
  const currentCategory = props.route.params.category;
  const currentSubCategory= props.route.params.subcategory;

  switch (currentCategory) {
    case 'Profile':
      hash = 'Preliminary-Interview-0';
      if (currentSubCategory === 'Preliminary Profile') {
        hash = 'General-Instructions-1';
      }
      else if (currentSubCategory === 'Conclusion to the Interview') {
        hash = 'Status-Determination-2';
      }
      break;
    case 'Review':
      hash = 'Application-Assessments-Review-4';
      if (currentSubCategory === 'Preliminary Profile') {
        hash = 'General-Instructions-5';
      }
      else if (currentSubCategory === 'Application') {
        hash = 'Application-Resume-7';
      }
      else if (currentSubCategory === 'Assessments') {
        hash = 'Assessments-8';
      }
      break;
    case 'Interview':
      hash = 'Application-Interview-12';
      if (currentSubCategory === 'Introduction') {
        hash = 'General-Instructions-13';
      }
      else if (currentSubCategory === 'Preferences Availability') {
        hash = 'Availability-Date-14';
      }
      else if (currentSubCategory === 'Work Objectives') {
        hash = 'Work-Objectives-15';
      }
      else if (!!~['Work Experience', 'Skills'].indexOf(currentSubCategory)) {
        hash = 'Work-Experience-Skills-16';
      }
      else if (currentSubCategory === 'Assessments') {
        hash = 'Assessments-17';
      }
      else if (currentSubCategory === 'Behavioral Interview') {
        hash = 'Behavioral-Questions-18';
      }
      else if (currentSubCategory === 'Determination of Status') {
        hash = 'Status-Determination-Conclusion-19';
      }
      break;
    default:
  }

  function phoneType(id) {
    if (id) {
      const phonType = _.find(props.staticData.phoneTypeList, {id});
      if(phonType && phoneType.name) {
        return phonType.name.replace('Mobile', 'Cell');
      }
    }
    return '';
  }

  function handleImpersonation() {
    impersonationApi.resetImpersonation(user.id)
    .then(() => {
      if (window) {
        const win = window.open('/applicant', 'applicant');
        win.focus();
      }
    });
  }

  function handleGuide() {
    if (window) {
      const win = window.open(`/admin/guide#${hash}`, 'guide');
      win.focus();
    }
  }

  return (
    <div className='front-card'
      data-id={`${user.email} front`}
      key={`Front Card ${props.applicant.profile.id}`}
      style={props.style}>
        <div className='status-flag-container clearfix'>
            <DropDownMenu style={{backgroundColor: props.statusColor}}
                          data-id='Status Dropdown'
                          className='applicant-status-dropdown'
                          value={selectedStatus}
                          menuItems={props.staticData.applicantStatus}
                          onChange={props.onStatusChange.bind(this, 'applicantStatus')}
                          {...dropDownCustomization}/>
        </div>
        <div className='main-card'>
          <div className='card-sections col-1'>
            <div className='name-container'>
              <div className='full-name' data-id='Full Name'>{`${user.firstName} ${user.middleName} ${user.lastName}`}</div>
              {
                user.nickName && _.trim(user.nickName) !== ''
                &&
                <div className='nickname' data-id='Nickname'>( {user.nickName} )</div>
              }
            </div>

            <div className='qs-container'>
              <div className='full-name' data-id='Full Name'>QS: {(qualifyingSpecialistsKeyById[profile.qualifyingSpecialistId]||{}).firstName} {(qualifyingSpecialistsKeyById[profile.qualifyingSpecialistId]||{}).lastName}</div>
            </div>

            {
              profile.availabilityDate
              &&
              <div><span className='date-heading'>Availability Date:</span> <span className='date'>{prettyDate(profile.availabilityDate)}</span></div>
            }

            <div className='updatedDate-email-address-contactTime-badges-container'>
              <div className='email' data-id='Email'>{emailLink(user.email)}</div>
              <div className='address'>{prettyAddress({...user, stateName})}</div>
              {
                false // this is going to be included in the future
                &&
                <div className='badge-container'>
              <RibbonIcon/>
              </div>
              }
            </div>
          </div>
          <div className='card-sections col-2'>
            <div className='state-timezone-container'>
              <div><span className='date-heading'>Applied:</span> <span className='date'>{prettyDate(profile.dateCreated)}</span></div>
              {
                profile.qualifiedDate &&
                <div><span className='date-heading'>Qualified:</span> <span className='date'>{prettyDate(profile.qualifiedDate)}</span></div>
              }
              {
                profile.dateModifiedByApplicant
                &&
                <div><span className='date-heading'>Updated:</span> <span className='date'>{prettyDate(profile.dateModifiedByApplicant)}</span></div>
              }
              <div className='timezone' data-id='Timezone'>{user.timezone.name}</div>
              <div className='contactTime'>Time to Contact: {user.bestContactTime.name || props.staticData.bestContactTimeList.find((time) => time.id === user.bestContactTime).name}</div>
              <div className='phoneNumbers-edit-container'>
              {
                new Array(3).fill(null).map((__, index) => (
                  user[`phoneNumber${index + 1}`]
              &&
              <div className='phoneNumber-container' key={index}>
              <span className='phoneType' data-id={`phoneType${index + 1}`}>{index === 0 ? `Main (${phoneType(_.get(user, `phoneType${index + 1}`))}):` : `${phoneType(_.get(user, `phoneType${index + 1}`))}:`}</span>
              <span className='phoneNumber' data-id={`phoneNumber${index + 1}`}>{prettyPhone(_.get(user, `phoneNumber${index + 1}`, ''))}</span>
              </div>
              ))
              }
              </div>
            </div>
          </div>

          <div className='card-sections col-3'>
            <div className='status-dropdown'>
            <DropDownMenu style={{backgroundColor: props.statusColor}}
            data-id='Status Dropdown'
            className='applicant-status-dropdown'
            value={selectedStatus}
            menuItems={props.staticData.applicantStatus}
            onChange={props.onStatusChange.bind(this, 'applicantStatus')}
            {...dropDownCustomization}/>
            </div>

            <div className='application-container'>
              <a target='_blank' className='view-resume-btn' href={`/admin/Qualified/${profile.id}/Profile/resume`}>
                <FlatButton className='view-resume-btn'
                            label='Resume'
                            />
              </a>
            {
              (selectedStatus !== APPLICANT_STATUS.NOT_QUALIFIED && _.intersection(currentUser.roles, ['Admin',
                'Qualifying Specialist',
                'Placement Specialist',
                'Reference Specialist',
                'Support Assistant'
              ]).length > 0)
              &&
                  <FlatButton className='view-resume-btn'
                              label={isQualified(parseInt(selectedStatus)) ? 'Record' : 'Application'}
                              onClick={handleImpersonation}
                              />
            }
            </div>

            <div className='action-container'>
              <IconButton tooltip='Edit' tooltipPosition='bottom-center' className='icon-btn' data-id='edit' onClick={props.stateToggle.bind(this, 'edit', 1)}>
                <EditIcon />
              </IconButton>
              <IconButton tooltip='Guide' tooltipPosition='bottom-center' className='icon-btn'  data-id='guide' onClick={handleGuide}>
                <GuideIcon/>
              </IconButton>
              <IconButton tooltip='Assessments' tooltipPosition='bottom-center' onClick={props.stateToggle.bind(this, 'edit', 2)}>
                <div className='scores-icon-wrapper'><a className='scores-icon' data-id='star' ></a></div>
              </IconButton>
              <IconButton tooltip='Document' tooltipPosition='bottom-center' className='icon-btn' data-id='document' onClick={props.stateToggle.bind(this, 'edit', 3)}>
                <DocumentIcon />
              </IconButton>
            </div>
          </div>

        </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./shared/react/r_ExpandedCard/f_FrontCard/index.js